module.exports = __webpack_public_path__ + "img/chatbot.0be09bc1.svg";